export default "__VITE_ASSET__Co4dy96J__"